import { EncryptionDecryption } from "common/utils/encrdecr.utility";

export enum RequestType {
    GET = 'get',
    BLANK = 'blank',
    ID = 'id',
    BACK = 'back',
}

export type SORTING_ORDER = '1' | '-1' | '0';

// Insatlmemt max year

export const instMaxYear = 2099;

export enum CommonListData {
    rowPerPage = 10,
    coBrandingPerPage = 12
}

export const StorageConstants = {
    plexToken: 'plex-token',
    kbhToken: 'kotakbh-token',
    crmMappingToken: 'crmmapping-token',
    userProfile: 'userProfile',
    loggedInCurrently: 'loggedInCurrently',
    distributorCart: 'distributorCart',
    lumpsumMetaData: 'lumpsumMetaData',
    sipMetaData: 'sipMetaData',
    pageNavHistoryInfo: 'pageNavHistoryInfo',
    indexedDBPageConstant: 'indexedDBPageConstant',
    lastNavigatedUrl: 'lastNavigatedUrl',
    lumpsumCart: 'lumpsumCart',
    sipCart: 'sipCart',
    zeroAUMValue: 'zeroAUMValue',
    pendingTransaction: 'pendingTransaction',
    curruntActiveTab: 'curruntActiveTab',
    transactionRefNo: 'transactionRefNo',
    redirectToCobrand: 'redirectToCobrand',
    redirectCobrandId: 'redirectCobrandId',
    redirectToOpp: 'redirectToOpp',
    userLogInfo: 'userLogInfo',
    currentPageState: 'currentPageState',
    kbhAccessToken: 'kbhAccessToken',
    kbhRefreshToken: 'kbhRefreshToken',
    isEmployeeLogin: 'isEmployeeLogin',
    deepLinkDetails: 'deepLinkDetails',
    mandateInvestor: 'mandateInvestor',
    ipAddress: 'ipAddress',
    userProfilePrelogin: 'userProfilePrelogin',
    currentUser: 'currentUser',
    loginUserType: 'loginUserType',
    isFromSessionStroageExpired: 'isFromSessionStroageExpired',
    hkeyToken: 'hkeyToken',
    isLoginSuccess: 'isLoginSuccess',
    isPreLoginInitiat: 'isPreLoginInitiat',
    userData: 'userData',
    redirectionUrl: 'redirectionUrl',
    isLoginSuccessOnMob: 'isLoginSucessOnMon'
};

export const TransactionStatusConstants = {
    pending: 'pending',
};

export const NavigateRoutes = {
    baselogin: '/login/',
    loginarn: '/login/arn',
    notifications: '/distributor/notifications',
    welcome: '/',
    veiwcertificate: '/view-certificate',
    viewContent: '/view-content/',
    setloginType: '/login/set-login-type',
    loginViaOtp: '/login/login-via-otp',
    preLoginTransaction: '/login/pre-login-transaction',
    loginKotakDistributor: '/login/kotak-distributor',
    loginKotakEmployee: '/login/kotak-employee',
    loginIndependentDistributor: '/login/independent-distributor',
    distributorprofile: '/distributor/profile',
    distributordashboard: '/distributor/dashboard',
    distributortransaction: '/distributor/transaction',
    transaction: '/distributor/transact',
    initiateTransaction: '/distributor/transact/select-transaction',
    selectInvestor: '/distributor/transact/investor-list',
    transactLumpsum: '/distributor/transact/lumpsum',
    transactLumpsumEdit: '/distributor/transact/lumpsum/edit',
    transactSwitch: '/distributor/transact/switch',
    transactRedeem: '/distributor/transact/redeem',
    transactSIP: '/distributor/transact/sip',
    transactSTP: '/distributor/transact/stp',
    transactSWP: '/distributor/transact/swp',
    transactSIPPause: '/distributor/transact/sip-pause',
    firstTimeTransactLumpsum: '/distributor/transact/lumpsum-first-time',
    firstTimeTransactstartSIP: '/distributor/transact/sip-first-time',
    firstTimeTransactzeroBalance: '/distributor/transact/zero-balance-folio',
    investor: '/distributor/investor',
    investorList: '/distributor/investor/investor-list',
    schemeList: '/distributor/investor/scheme-list',
    investorDetails: '/distributor/investor/investor-details',
    schemeDetails: '/distributor/investor/scheme-list/scheme-details',
    folioDetails: '/distributor/investor/investor-list/folio-details',
    transactionCart: '/distributor/transact/cart',
    transactionPayment: '/distributor/transact/payment',
    transactionSummary: '/distributor/transact/summary',
    transactionSwitch: '/distributor/transact/switch',
    transactionRedeem: '/distributor/transact/redeem',
    transactionThankYou: '/distributor/transact/thank-you',
    pendingTransaction: '/distributor/transact/pending-transaction',
    sipPause: '/distributor/transact/sip-pause',
    sipReport: '/distributor/sip-report',
    stpReport: '/distributor/stp-report',
    swpReport: '/distributor/swp-report',
    stopTransaction: '/distributor/transact/stop-transaction',
    otm: '/distributor/transact/otm',
    transactionHistory: '/distributor/transaction-history',
    transactionDetails: '/distributor/transaction-history/transaction-details',
    oppotunity: '/distributor/opportunity',
    sipOpportunity: '/distributor/opportunity/sip-opportunity',
    sipOpportunityList: '/distributor/opportunity/sip-opportunity/sip-opportunity-list',
    crossSellOpportunity: '/distributor/opportunity/cross-sell-opportunity',
    crossSellOpportunityList: '/distributor/opportunity/cross-sell-opportunity/cross-sell-oppotunity-list',
    activationOpportunity: '/distributor/opportunity/activation-opportunity',
    activationOpportunityList: '/distributor/opportunity/activation-opportunity/activation-opportunity-list',
    otherOpportunity: '/distributor/opportunity/other-opportunity',
    otherOpportunityList: '/distributor/opportunity/other-opportunity/other-opportunity-list',
    prostartVideos: '/distributor/prostart',
    statement: 'statement',
    accoutStatments: '/distributor/transact/investor-list/account-statement',
    capitalGainStatements: '/distributor/transact/investor-list/capital-gain-statement',
    accountStatement: '/distributor/account-statement',
    capitalGainStatement: '/distributor/capital-gain-statement',
    // brokeragereport: '/distributor/brokerage-report',
    nav: '/distributor/nav',
    birthday: '/distributor/birthday',
    anniversary: '/distributor/anniversary',
    festival: '/distributor/festival',
    wishes: '/distributor/wishes',
    wishesListing: '/distributor/wishes/wishes-listing',
    wishesMessages: '/distributor/wishes/wishes-msg',
    feedBackAndQuery: '/distributor/feedback-and-queries',
    noInternet: '/distributor/no-internet',
    birthDayWish: '/distributor/birthday-wishes',
    coBranding: '/distributor/co-branding',
    coBrandingDetail: '/distributor/co-branding/detail/',
    coBrandingLoading: '/distributor/co-branding/progress/',
    contactUs: '/distributor/contact-us',
    goalPlanner: '/distributor/goal-planner',
    empanelment: '/empanelment',
    empanelmentForm: '/empanelment/empanelment-form',
    empanelmentCongratulations: '/empanelment/congratulations',
    bankMandateListing: '/distributor/bankmandate-list',
    bankMandateForm: '/distributor/bankmandate-form',

    //Nominee Details
    nomineeDetails: '/distributor/nominee-details',
    contactDetails: '/distributor/transact/contact-details',

    //Brokerage Report payout
    brokeragereportpayout: '/distributor/brokerage-report-payout',
    brokeragereport: '/distributor/brokerage-report-payout/brokerage-report',
    ratecard: '/distributor/brokerage-report-payout/rate-card',
};

export const aumMilstone = [1, 3, 5, 10, 25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500];
export const sipMilstone = [0, 25, 50, 75, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700, 750, 800, 850, 900, 950, 1000, 1050, 1300, 1150, 1200, 1250, 1300, 1350, 1400, 1450, 1500, 1550, 1600, 1650, 1700, 1750, 1800, 1850, 1900, 1950, 2000];

export const TransactionModule = {
    switch: 'switch',
    redeem: 'redeem',
    stp: 'stp',
    sip: 'sip',
    sipPause: 'sip-pause',
    swp: 'swp',
    lumpsum: 'lumpsum',
    lumpsumFirstTime: 'lumpsum-firsttime',
    sipFirstTime: 'sip-firsttime',
    zbf: 'zbf',
    additionalPurchase: 'additional purchase',
    stop: 'stop',
    otm: 'otm',
    contact: 'contact',
};

export const CobrandModuleContentType = {
    all: 'ALL',
    pdf: 'PDF',
    image: 'IMAGE',
    video: 'VIDEO',
    html: 'HTML',
    gif: 'GIF',
};
export const cobrandContenList = [
    {
        key: 'ALL',
        value: 'ALL'
    },
    {
        key: 'PDF',
        value: 'PDF'
    },
    {
        key: 'IMAGE',
        value: 'IMAGE'
    },
    {
        key: 'VIDEO',
        value: 'VIDEO'
    },
    {
        key: 'HTML',
        value: 'HTML'
    },
    {
        key: 'GIF',
        value: 'GIF'
    }
];

export const UpdateContactType = {
    mobile: 'CHANGEMOBILE',
    email: 'CHANGEEMAIL',
};

export const ExcludeRouteForExitTransaction = [
    NavigateRoutes.transactSwitch,
    NavigateRoutes.transactRedeem,
    NavigateRoutes.transactLumpsum,
    NavigateRoutes.transactSIP,
    NavigateRoutes.transactSTP,
    NavigateRoutes.transactSWP,
    NavigateRoutes.sipPause,
    NavigateRoutes.firstTimeTransactLumpsum,
    NavigateRoutes.firstTimeTransactstartSIP,
    NavigateRoutes.firstTimeTransactzeroBalance,
    NavigateRoutes.transactionSummary,
    NavigateRoutes.transactionCart,
    NavigateRoutes.transactionPayment,
    NavigateRoutes.transactionThankYou,
    NavigateRoutes.stopTransaction,
    NavigateRoutes.otm,
    NavigateRoutes.contactDetails,
    NavigateRoutes.bankMandateForm,
    NavigateRoutes.bankMandateListing,
];

export const TransactionClosePage = {
    lumpsum: 'lumpsum',
    sip: 'sip',
    lumpsumFirstTime: 'lumpsum-firsttime',
    sipFirstTime: 'sip-firsttime',
    cart: 'cart',
    payment: 'payment',
    summary: 'summary',
};

export const PageFromRoutingPendingTransaction = {
    [TransactionClosePage.lumpsum]: NavigateRoutes.transactLumpsum,
    [TransactionClosePage.sip]: NavigateRoutes.transactSIP,
    [TransactionClosePage.lumpsumFirstTime]: NavigateRoutes.firstTimeTransactLumpsum,
    [TransactionClosePage.sipFirstTime]: NavigateRoutes.firstTimeTransactstartSIP,
    [TransactionClosePage.cart]: NavigateRoutes.transactionCart,
    [TransactionClosePage.payment]: NavigateRoutes.transactionPayment,
};

export const TransactionStatus = {
    all: 'all',
    pending: 'Pending for confirmation',
    confirmed: 'CONFIRMED',
    expired: 'Link Expired',
};

export const TicketStatus = {
    pending: 'PENDING',
    closed: 'CLOSED',
};

export const NetworkSpeedMsg = {
    offline: 'Your device is offline. Please check internet connection.',
    online: 'Back online.',
};

export const StatementType = {
    account: 'account',
    capitalGain: 'capitalgain',
};

export const OTPStatus = {
    sent: 'sent',
    verified: 'verified',
    failed: 'failed',
};

export const OTPCountDown = {
    duration: 30,
};

export const SchemeOptions: any = {
    reinvest: { viewValue: 'Reinvest', formValue: 'Y' },
    payout: { viewValue: 'Payout', formValue: 'N' },
    notApplicable: { viewValue: 'Not Applicable', formValue: 'Z' },
};

export const TranSaveDataConst: any = {
    status: 'Pending for confirmation',
    type: 'POSTLOGIN',
};

export const TRANSACTION_TYPE = [
    { id: 'SIP', name: 'Systematic Investment Plan' },
    { id: 'STP', name: 'Systematic Transfer Plan' },
    { id: 'SWP', name: 'Systematic Withdrawal Plan' },
];
const decryptM = new EncryptionDecryption().decrypt('spAxUJjFwqC4gLoV0LwDvA==');
const decryptE = new EncryptionDecryption().decrypt('lGU2J5jl8nsqS83VHwBJUABYXpG7x1reT3Rk3OgsqSI=');
export const decryptN = new EncryptionDecryption().decrypt('LsZ6YQFUYF/oH2Tzf1n28Fftk/S1UAwokstOfEUYSlk=');
const decryptP = new EncryptionDecryption().decrypt('SFpODddyEGbRcRQoWuWX5g==');
export const keyToken = new EncryptionDecryption().decrypt('3n0PHdahwcNXiNkPPukXwg==');
export const plexPass = new EncryptionDecryption().decrypt('nw4nncgZ2lnF5qq7czvxjA==');
export const plexUName = new EncryptionDecryption().decrypt('2GsmKUSQ5DIHNAd5VtpcGw==');
export const KmamcSubscriptionKey = new EncryptionDecryption().decrypt('tjlduimtpvlhXnqoo0Iw/cf9H/unByenPQt8bUJj2ri93OgaydSlHSzNowXZncIU');
export const plexUToken = new EncryptionDecryption().decrypt('lzCFMoRGhQsLdZkEV9BAexiu/hCDc-om7LrKNYJCh87rHCnGQxUItaK59Gjwp2Tf247zFARUC-nrUaRVzdGHxkpnlZEymp1MS1eCAgPKNu0=');
export const QK_CONSTATANT = ['ARN-QK-TEAM', 'ARN-QK-TEAM_KOTAK', 'QK-TEAM', 'QK-TEAM_KOTAK'];
export const QK_BROCKER = {
    Broker_Name: decryptN,
    Broker_Type: 'IFA',
    BROKER_CODE: 'ARN-QK-TEAM',
    MOBILE_NO: decryptM,
    EMAIL: decryptE,
    EMPLSTATUS: 'EMPANELLED',
    PAN_NO: decryptP,
    postLoginRedirection: '',
};


export const TECH_CONSTATANT = ['ARN-TECH-USER', 'ARN-TECH-USER_KOTAK', 'TECH-USER', 'TECH-USER_KOTAK'];

export const TECH_BROCKER = {
    Broker_Name: decryptN,
    Broker_Type: 'IFA',
    BROKER_CODE: 'ARN-TECH-USER',
    MOBILE_NO: decryptM,
    EMAIL: decryptE,
    EMPLSTATUS: 'EMPANELLED',
    PAN_NO: decryptP,
    postLoginRedirection: '',
};

export const PEP_OPTIONS = [
    { pep_id: 'PEP', pep_text: 'Politically Exposed Person(PEP)' },
    { pep_id: 'RPEP', pep_text: 'Related To Politically Exposed Person(RPEP)' },
    { pep_id: 'NA', pep_text: 'Not Applicable' },
];

export const FATCA_PARAMS = [
    { id: 0, controls: ['taxResidency1', 'taxId1', 'taxIdType1'], residentVariable: 'isResidentOfCountry' },
    { id: 1, controls: ['joinTaxResidency1', 'joinTaxId1', 'joinTaxIdType1'], residentVariable: 'isResidentOfCountryJoinHolder' },
    { id: 2, controls: ['joinSecondTaxResidency1', 'joinSecondTaxId1', 'joinSecondTaxIdType1'], residentVariable: 'isResidentOfCountryJoinHolder2' },
];

export const FATCA_VALIDATOR_PARAMS = [
    { id: 0, type: 'primary', controls: ['grossIncome', 'netWorth', 'netWorthDate', 'occupation', 'sourceOfWealth', 'pep', 'countryOfBirth', 'addressType', 'residenceAddress'] },
    { id: 1, type: 'firstJoin', controls: ['grossIncomeJoinHolder', 'netWorthJoinHolder', 'netWorthDateJoinHolder', 'occupationJoinHolder', 'sourceOfWealthJoinHolder', 'pepJoinHolder', 'countryOfBirthJoinHolder', 'addressTypeJoinHolder', 'residenceAddressJoinHolder'] },
    { id: 2, type: 'secondJoin', controls: ['grossIncomeJoinHolder2', 'netWorthJoinHolder2', 'netWorthDateJoinHolder2', 'occupationJoinHolder2', 'sourceOfWealthJoinHolder2', 'pepJoinHolder2', 'countryOfBirthJoinHolder2', 'addressTypeJoinHolder2', 'residenceAddressJoinHolder2'] },
];

export const TRANSACTION_MODE = [
    { id: 'ON', name: 'Online' },
    { id: 'OFF', name: 'Offline' },
];

export const AC_TYPENRINRO = [
    {
        name: 'NRI - Repatriable (NRE)',
        value: 'NRE',
    },
    {
        name: 'NRI - Non-Repatriable (NRO)',
        value: 'NRO',
    },
];

export const smallCapFundSchemeCode = ['104', '114', '104D', '114D'];

export const profileImageSize = 175;
export const birthdayWishesId = 159;

export const MonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const unitAllotmentPDFURL = 'https://vatseelabs-s3.kotakmf.com/FormsDownloads/Unit-Allotment-Grid/UnitAllotmentGrid.pdf';

export const NavHistoryRedirectionURL = 'https://kotakmf.com/mutual-funds/';

export const taxStatus = [
    {
        TAX_STATUS_CODE: '01',
        TAX_STATUS_DESC: 'Individual',
        RESIDENT_FLAG: 'RESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'N',
        NOMINEE: 'Y',
    },
    {
        TAX_STATUS_CODE: '03',
        TAX_STATUS_DESC: 'HUF',
        RESIDENT_FLAG: 'RESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'N',
        NOMINEE: 'N',
    },
    {
        TAX_STATUS_CODE: '27',
        TAX_STATUS_DESC: 'NRI (HUF)',
        RESIDENT_FLAG: 'NONRESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'N',
        NOMINEE: 'N',
    },
    {
        TAX_STATUS_CODE: '26',
        TAX_STATUS_DESC: 'NRI (MINOR)',
        RESIDENT_FLAG: 'NONRESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'Y',
        NOMINEE: 'N',
    },
    {
        TAX_STATUS_CODE: '29',
        TAX_STATUS_DESC: 'NRI-HUF(NRE)',
        RESIDENT_FLAG: 'NONRESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'N',
        NOMINEE: 'N',
    },
    {
        TAX_STATUS_CODE: '13',
        TAX_STATUS_DESC: 'SOLE PROPRIETORSHIP',
        RESIDENT_FLAG: 'RESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'N',
        NOMINEE: 'Y',
    },
    {
        TAX_STATUS_CODE: '28',
        TAX_STATUS_DESC: 'NRI - Minor (NRO)',
        RESIDENT_FLAG: 'NONRESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'Y',
        NOMINEE: 'N',
    },
    {
        TAX_STATUS_CODE: '21',
        TAX_STATUS_DESC: 'NRI - Repatriable (NRE)',
        RESIDENT_FLAG: 'NONRESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'N',
        NOMINEE: 'Y',
    },
    {
        TAX_STATUS_CODE: '11',
        TAX_STATUS_DESC: 'NRI - Non-Repatriable (NRO)',
        RESIDENT_FLAG: 'NONRESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'N',
        NOMINEE: 'Y',
    },
    {
        TAX_STATUS_CODE: '02',
        TAX_STATUS_DESC: 'On Behalf Of Minor',
        RESIDENT_FLAG: 'RESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'Y',
        NOMINEE: 'N',
    },
    {
        TAX_STATUS_CODE: '24',
        TAX_STATUS_DESC: 'NRI - Non-Repatriable (NRO)',
        RESIDENT_FLAG: 'NONRESIDENT',
        ENTRY_TIME: '20240208114600',
        MINOR: 'N',
        NOMINEE: 'Y',
    },
];

export const keyAndPassword: string = 'KMF_API1';

export const formValidationCheck = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', // fragment locator
    'i'
);
export const emailConstantRegex = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';

export const updateCugApiEndPoint = ['DistributorAddMandateKBH', 'GETNomineeDistributorKBH', 'STOPTRANSACTIONDISTRIBUTORKBH', 'DISSUBMIT'];

export enum AppMsg {
    KYC_NOT_VERIFIED = 'Transaction Not Allowed: Folio inactive or invalid. Check details or contact CAMS.',
    TRANSACTION_NOT_ALLOW = 'You are not allowed to proceed with the transaction.',
    JOIN_HOLDING_NATURE = 'Transaction cannot be allowed. Joint account',
}
